import { axios } from './general'
import type {
  OrderProfileReq,
  OrderResponse,
  PackageListParams,
  packageListResponse,
  QueryProfilesReq,
  QueryProfilesRes,
  InvoiceDetail
} from './types/esimPackage'

const affiliateTrackerHeaders = () => ({
  // @ts-ignore require tracker.js from BE
  'X-affiliate-tracker': window._esimAffiliateTracker?.id
})

export const useEsimAccess = (domain = '') => {
  const getPackages = async (payload: PackageListParams, signal?: AbortSignal) => {
    const res = await axios.post<packageListResponse>(`/handler/access/list`, { ...payload, domain }, { signal })
    return res.data
  }

  const createOrder = async (payload: OrderProfileReq, signal?: AbortSignal) => {
    const res = await axios.post<OrderResponse>(`/handler/access/order`, { ...payload, domain }, {
      signal,
      headers: affiliateTrackerHeaders()
    })
    return res.data
  }

  const queryProfiles = async (payload: QueryProfilesReq, signal?: AbortSignal) => {
    const res = await axios.post<QueryProfilesRes>(`/handler/access/query-profiles`, payload, { signal })
    return res.data
  }

  const getUsage = async (payload: OrderProfileReq, signal?: AbortSignal) => {
    const res = await axios.post<QueryProfilesRes>(`/handler/access/usage-query`, payload, { signal })
    return res.data
  }

  const getInvoice = async (invoiceId: string, signal?: AbortSignal) => {
    const res = await axios.get<InvoiceDetail>(`/handler/invoice/${invoiceId}`, { signal })
    return res.data
  }

  return {
    getPackages,
    createOrder,
    queryProfiles,
    getUsage,
    getInvoice,
  }
}
